import React from 'react'
import {withRouter } from 'react-router-dom'

const LoginForm = (props) => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="form-input">
                <label>Email</label>
                <input type="email" name="username" value={props.username} onChange={props.onChange} />
                <span className="error">{props.errors.username}</span>
            </div>
            <div className="form-input">
                <label>Password</label>
                <input type="password" name="password" value={props.password} onChange={props.onChange} />
                <span className="error">{props.errors.password}</span>
            </div>
            <div className="form-input">
                <label>OTP</label>
                <input type="password" name="ottp" value={props.ottp} onChange={props.onChange} />
                <span className="error">{props.errors.ottp}</span>
            </div>
            <div className="actions">
                <button className={props.processing ? 'disabled' : ''}>Login</button>
            </div>
        </form>
    )
}

export default withRouter(LoginForm)